import { completeInquiryTiming, failInquiryTiming, hasPendingInquiry } from "./inquiryTiming";
import { useTrackPendingQuery, type PendingQueryState } from "./pendingQueryTracking";

export interface PendingInquiryQueryState extends PendingQueryState {}

const inquiryQueryTracker = {
  hasPending: hasPendingInquiry,
  complete: completeInquiryTiming,
  fail: failInquiryTiming,
  unknownErrorMessage: "Unknown inquiry error",
};

export function useTrackPendingInquiry(id: string, state: PendingInquiryQueryState) {
  useTrackPendingQuery(id, state, inquiryQueryTracker);
}
